import { call, put, select, takeLatest } from 'redux-saga/effects';
import { fetchCategoriesFailure, fetchCategoriesStart, fetchCategoriesSuccess, loadCategoriesRequest } from '../categoriesSlice';
import { getCategoriesApi } from '../../api/apiLists/getCategoriesApi';
import { modularizeCategoriesResponse } from '../../utils/handleCRMResponse';
import { callWithAuth } from '../sagaApiHelper';
import { getCategoriesFromStorage, saveCategoriesToStorage } from '../../utils/apiCacheHelper';

function* handleFetchCategories() {

    try {
        yield put(fetchCategoriesStart());
        
        const cachedData = getCategoriesFromStorage();
        if (cachedData) {
            yield put(fetchCategoriesSuccess(cachedData));
            return;
        }
        
        const companyId = yield select((state) => state.auth?.user?.companyId);
        const res = yield call(callWithAuth, getCategoriesApi, ["en", companyId]);
        const { productCategories, serviceRequestCategories } = res.data;

        const { categoryOptions: productCategoriesList, subcategoryMap: productSubCategoriesMap, modelMap: productModelMap  } = modularizeCategoriesResponse(productCategories);
        const { categoryOptions: serviceRequestCategoriesList, subcategoryMap: serviceRequestSubCategoriesMap } = modularizeCategoriesResponse(serviceRequestCategories);

        const categoriesData = {
            productCategoriesList,
            productSubCategoriesMap,
            productModelMap,
            serviceRequestCategoriesList,
            serviceRequestSubCategoriesMap,
        };

        saveCategoriesToStorage(categoriesData);
        yield put(fetchCategoriesSuccess(categoriesData));
    } catch (error) {
        yield put(fetchCategoriesFailure({ error: error.message }));
    }
}

export default function* categoriesSaga() {
    yield takeLatest(loadCategoriesRequest.type, handleFetchCategories);
}
